'use client';

import { SLOW_CADENCE_MS } from '../api/keys';
import { useRiskMetrics } from './use-risk-metrics';

/**
 * The period table's queries, owned by the view rather than the table: a
 * query the view cannot see is one its recovery banner cannot report and
 * its retry cannot refetch, which left a failed row as a bare dash.
 */
export function usePeriodReturns() {
  // Five parallel windows at the slow cadence: the numbers move daily, and
  // polling them by the minute trips the API rate limiter.
  const cadenceMs = SLOW_CADENCE_MS;
  // Each row carries the window it asks for: its identity, which the
  // table reads instead of the served echo.
  return [
    {
      label: '1M',
      window: '30d',
      query: useRiskMetrics({ window: '30d', cadenceMs })
    },
    {
      label: '3M',
      window: '90d',
      query: useRiskMetrics({ window: '90d', cadenceMs })
    },
    {
      label: 'YTD',
      window: 'ytd',
      query: useRiskMetrics({ window: 'ytd', cadenceMs })
    },
    {
      label: '1Y',
      window: '365d',
      query: useRiskMetrics({ window: '365d', cadenceMs })
    },
    {
      label: 'Since start',
      window: 'inception',
      query: useRiskMetrics({ window: 'inception', cadenceMs })
    }
  ] as const;
}
